import Marquee from "react-fast-marquee";
import { Flame } from "lucide-react";

const ITEMS = [
  "SAME-DAY SWAP-OUTS",
  "UPFRONT PRICES ONLINE",
  "LIFETIME LABOUR WARRANTY",
  "HAPPINESS GUARANTEE",
  "GAS + ELECTRIC UNDER ONE ROOF",
  "LIVE BOOKING AVAILABILITY",
  "FREE COFFEE WITH 7AM BOOKINGS",
];

export default function MarqueeRibbon() {
  return (
    <div className="bg-tpeco-blue overflow-hidden py-3" data-testid="marquee-wrap">
      <div className="bg-tpeco-pink border-y-4 border-tpeco-ink py-3 -rotate-1 scale-[1.02]" data-testid="marquee-ribbon">
      <Marquee speed={35} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="flex items-center font-display text-2xl sm:text-3xl uppercase tracking-wide text-white">
            <span className="mx-6">{item}</span>
            <Flame className="w-5 h-5" strokeWidth={2.5} />
          </span>
        ))}
      </Marquee>
      </div>
    </div>
  );
}
